// extracted by mini-css-extract-plugin
export default {"lowStockLabel":"vma-z"};